module.exports = __webpack_public_path__ + "img/user_img.a8a3dd62.png";